<app-form-field-wrapper [fieldName]="label()">
  <mat-form-field appearance="outline" class="w-full">
    @if (prefixIcon()) {
      <mat-icon matPrefix class="text-on-surface-variant mr-1">{{ prefixIcon() }}</mat-icon>
    }
    <input
      matInput
      placeholder="••••••••"
      [type]="show() ? 'text' : 'password'"
      [autocomplete]="autocomplete()"
      [formField]="field()"
    />
    <button matIconButton matSuffix type="button" (click)="show.set(!show())">
      <mat-icon>{{ show() ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
    @if (state().touched() && state().invalid()) {
      <mat-error>{{ state().errors()[0].message }}</mat-error>
    }
  </mat-form-field>
</app-form-field-wrapper>
